import { Button, Space } from 'antd-mobile';
import React, { useState } from 'react';


const Reconnect = ({ onReconnect, onHome }) => {
    const [countdown, setCountdown] = useState(0);
    const [isCountingDown, setIsCountingDown] = useState(false);

    const handleReconnect = () => {
        if (isCountingDown) return;

        setIsCountingDown(true);
        setCountdown(5);

        const countdownInterval = setInterval(() => {
            setCountdown((prev) => {
                if (prev === 1) {
                    clearInterval(countdownInterval);
                    onReconnect(); // Fire the reconnect function when countdown ends
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    if (isCountingDown) {
        return (
            <div style={{ maxWidth: '250px', textAlign: 'center' }}>
                Reconnecting in {countdown}
            </div>
        )
        
    }

    return (
        <div style={{ maxWidth: '250px', textAlign: 'center' }}>
            <small>
                This station has been disconnected because it is currently in use at another location.
                <div className="shim" />
                <div className="shim" />
                Please check and ensure that only one instance of the station is active at a time to avoid conflicts.
            </small>
            <br /><br />
            <Space>
                <Button disabled={isCountingDown} onClick={onHome}>Reload</Button>
                <Button color="success" onClick={handleReconnect}>Reconnect</Button>
            </Space>
        </div>
    );
};

export default Reconnect;
